// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__na9q7","text":"SelectPayment_text__1Y1py","title":"SelectPayment_title__3WIQB","btn":"SelectPayment_btn__3RsSB"};